class CookiesPopup {
    /** @var {HTMLFormElement} */
    form;

    constructor(el) {
        this.$el = el;
        setTimeout(() => el.classList.add('is-active'), 1000);
        this.fineControl = el.querySelector('[data-fine-control]');
        this.default = el.querySelector('[data-default]');
        el.querySelector('[data-open-fine]').addEventListener('click', e => this.toggleFineControl(e, true));
        el.querySelector('[data-close-fine]').addEventListener('click', e => this.toggleFineControl(e, false));
        el.querySelectorAll('[data-control]').forEach(el => el.addEventListener('click', e => this.cookiesSwitch(e)));
        this.toggles = el.querySelectorAll('input[type=checkbox]');
        this.form = el.querySelector('form');
        this.form.addEventListener('submit', e => this.onFormSubmitted(e));
    }

    onSuccess() {
        this.$el.classList.remove('is-active');
    }

    /**
     * @param {MouseEvent} e
     * @param {Boolean} show
     */
    toggleFineControl(e, show) {
        e.preventDefault();
        this.default.classList.toggle('u-hidden', show);
        this.fineControl.classList.toggle('u-hidden', !show);
    }

    /**
     * @param {MouseEvent} e
     */
    cookiesSwitch(e) {
        const toggle = Number.parseInt(e.currentTarget.dataset.toggle);
        this.toggles.forEach(el => el.checked = toggle === 1);

        const cookieConsentManager = new LinkCookieConsentManager(e.currentTarget.dataset.href);
        cookieConsentManager.sendSelectedValues(this.onSuccess.bind(this));
    }

    onFormSubmitted(e) {
        e.preventDefault();
        const data = new FormData(this.form);
        const cookieConsentManager = new FormCookieConsentManager(this.form.action, data);
        cookieConsentManager.sendSelectedValues(this.onSuccess.bind(this));
    }

}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-cookies-popup]').forEach(el => new CookiesPopup(el));
});
